import Backbone from 'backbone'
import template from './text-replacement.hbs'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import textTransformer from './text-transformer'

var TextReplacement = Backbone.View.extend({

	className: 'replacement-preview',

	events: {
		'keyup input': 'update'
	},

	initialize: function(options = {}) {
		this.options = options
		_.defaultsDeep(this.options, {
			labels: {
				before: i18n.get('report.customReport.massedit.before'),
				after: i18n.get('report.customReport.massedit.after')
			}
		})
		if (_.isEmpty(this.options.replacementType)) {
			this.options.replacementType =  'exact-phrase'
		}

	},

	render: function() {
		this.$el.empty().append(template(this.context()))
		this.toggleInputs()
		this.update()
		return this
	},

	toggleInputs: function() {
		var replacementType = this.options.replacementType
		if (replacementType === 'exact-phrase') {
			this.$('.replace-this-row, .with-this-row').removeClass('is-not-displayed')
		}
		if (replacementType === 'entire') {
			this.$('.with-this-row').removeClass('is-not-displayed')
		}
		if (replacementType === 'between-phrases') {
			this.$('.between-phrases-row, .with-this-row ').removeClass('is-not-displayed')
		}
		if (replacementType === 'prepend') {
			this.$('.with-this-label').html(i18n.get('report.customReport.massedit.prependThis'))
			this.$('.with-this-row').removeClass('is-not-displayed')
		}
		if (replacementType === 'append') {
			this.$('.with-this-label').html(i18n.get('report.customReport.massedit.appendThis'))
			this.$('.with-this-row').removeClass('is-not-displayed')
		}

	},

	update () {
		var results = textTransformer.defaults()
		var replacementType = this.options.replacementType
		var newText = this.$('.new-text').val()
		var textToReplace = this.$('.text-to-replace').val()
		var textBefore = this.$('.text-before').val()
		var textAfter = this.$('.text-after').val()
		if (replacementType === 'entire') {
			var input = this.$('.new-text')
			results = textTransformer.entire(newText)
		}
		if (replacementType === 'prepend') {
			var input = this.$('.new-text')
			results = textTransformer.prepend(newText)
		}
		if (replacementType === 'append') {
			var input = this.$('.new-text')
			results = textTransformer.append(newText)
		}
		if (replacementType === 'exact-phrase') {
			results = textTransformer.exact(textToReplace, newText)
		}
		if (replacementType === 'between-phrases') {
			results = textTransformer.between(textBefore, textAfter, newText)
		}
		this.$('.before').text(results.before)
		this.$('.after').html(results.after)

	},

	context: function() {
		return this.options
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
	}

})

export default TextReplacement

TextReplacement.__filename__ = 'admin/mass-edit/text-replacement.js'
